import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export interface WholesalerBranding {
  wholesaler_id: string;
  brand_name: string;
  logo_url: string | null;
  favicon_url: string | null;
  primary_color: string;
  secondary_color: string;
  custom_admin_domain: string | null;
  retailer_signup_domain: string | null;
  support_email: string | null;
}

interface WholesalerBrandingState {
  branding: WholesalerBranding | null;
  isWhiteLabelDomain: boolean;
  isLoading: boolean;
}

const initialState: WholesalerBrandingState = {
  branding: null,
  isWhiteLabelDomain: false,
  isLoading: false,
};

export const fetchWholesalerBrandingByDomain = createAsyncThunk(
  'wholesalerBranding/fetchByDomain',
  async (domain: string, { rejectWithValue }) => {
    try {
      const baseUrl = process.env.NEXT_PUBLIC_CRESIVOX_BASE_URL || '';
      const res = await fetch(`${baseUrl}/wholesaler-branding/by-domain?domain=${encodeURIComponent(domain)}`);
      const data = await res.json();
      if (res.ok && data?.data) {
        return data.data as WholesalerBranding;
      }
      return rejectWithValue('not_a_white_label_domain');
    } catch {
      return rejectWithValue('fetch_failed');
    }
  },
);

const wholesalerBrandingSlice = createSlice({
  name: 'wholesalerBranding',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWholesalerBrandingByDomain.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchWholesalerBrandingByDomain.fulfilled, (state, action) => {
        state.isLoading = false;
        state.branding = action.payload;
        state.isWhiteLabelDomain = true;
      })
      .addCase(fetchWholesalerBrandingByDomain.rejected, (state) => {
        state.isLoading = false;
        state.branding = null;
        state.isWhiteLabelDomain = false;
      });
  },
});

export default wholesalerBrandingSlice.reducer;
